import { AnalyticsPageContext } from "hooks/useAnalytics/pages/context";
import { SearchQueryOrderDirection } from "types/generated";

enum FilterItemKeys {
  Name = "name",
  Space = "space",
  CreatedAt = "createdAt",
}

export const INITIAL_SORT_OPTION = FilterItemKeys.CreatedAt;
export const INITIAL_SORT_DIRECTION = SearchQueryOrderDirection.Desc;
export const FILTERS_ORDER_SETTINGS_KEY = "contextsFiltersOrder";

export const FILTER_TYPE = "contexts";
export const CONTEXTS_LIMIT = 50;
export const CONTEXTS_LIMIT_STORAGE_KEY = "contextsLimit";

export const ANALYTICS = {
  analyticsPage: AnalyticsPageContext.ContextsList,
};
